import { render } from "./ReportsSystemView.vue?vue&type=template&id=510e2dd5&scoped=true"
import script from "./ReportsSystemView.vue?vue&type=script&lang=js"
export * from "./ReportsSystemView.vue?vue&type=script&lang=js"

import "./ReportsSystemView.vue?vue&type=style&index=0&id=510e2dd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e2dd5"]])

export default __exports__